import React from 'react';
import { connect } from 'react-redux';
import * as d3 from "d3";
import { Button, Tooltip } from 'antd';
import LinkerActions from '../../redux/LinkerActions';
import i18n from "i18next";
const webvowl = require("../../webvowl/entry");
const owlResponseHelper = require("./owlHelper");
const vowlResponseHelper = require("./vowlHelper");

/** Отображение графа на основе запросов к SPARQL. Контейнер определяется
 * в <div ref={viz => (this.viz = viz)} id="graph"></div>
 * 
 * webvowl - JSON объект для отрисовки графа. 
 * Для прорисовки используются результаты SPARQL Запроса.
 * 
 * this.refs - устаревший доступ к DOM, 
 * иногда вызовы идут как обработка события, например когда resize this.refs = undefinded, т.е. не работает
 */
window.webvowl = webvowl;
webvowl.modules.subclassFilter = require("../../webvowl/modules/subclassFilter");

String.prototype.replaceAll = function (search, replacement) {
	var target = this;
	return target.split(search).join(replacement);
};
const hashCode = s => s.split('').reduce((a,b)=>{a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);

var newOntologyCounter = 1;
var graph = webvowl.graph(),
	owlParser = require("./owlParser")(graph),
	options = graph.graphOptions(),
	languageTools = webvowl.util.languageTools(),
	GRAPH_SELECTOR = "#graph",
	// Modules for the webvowl app
	exportMenu = require("../emd/menu/exportMenu")(graph),
	filterMenu = require("../emd/menu/filterMenu")(graph),
	gravityMenu = require("../emd/menu/gravityMenu")(graph),
	modeMenu = require("../emd/menu/modeMenu")(graph),
	debugMenu = require("../emd/menu/debugMenu")(graph),
	ontologyMenu = require("../emd/menu/ontologyMenu")(graph),
	pauseMenu = require("../emd/menu/pauseMenu")(graph),
	resetMenu = require("../emd/menu/resetMenu")(graph),
	searchMenu = require("../emd/menu/searchMenu")(graph),
	navigationMenu = require("../emd/menu/navigationMenu")(graph),
	zoomSlider = require("../emd/menu/zoomSlider")(graph),
	sidebar = require("./sparqlSidebar").default(graph),
	leftSidebar = require("../emd/leftSidebar")(graph),
	editSidebar = require("../emd/editSidebar").default(graph),
	configMenu = require("../emd/menu/configMenu")(graph),
	loadingModule = require("./sparqlLoadingModule")(graph),
	warningModule = require("../emd/warningModule.cjs")(graph),
	directInputMod = require("../emd/directInputModule")(graph),
	linker = require("./linker")(graph),


	// Graph modules
	colorExternalsSwitch = webvowl.modules.colorExternalsSwitch(graph),
	compactNotationSwitch = webvowl.modules.compactNotationSwitch(graph),
	datatypeFilter = webvowl.modules.datatypeFilter(),
	disjointFilter = webvowl.modules.disjointFilter(),
	focuser = webvowl.modules.focuser(graph),
	emptyLiteralFilter = webvowl.modules.emptyLiteralFilter(),
	nodeDegreeFilter = webvowl.modules.nodeDegreeFilter(filterMenu),
	nodeScalingSwitch = webvowl.modules.nodeScalingSwitch(graph),
	objectPropertyFilter = webvowl.modules.objectPropertyFilter(),
	pickAndPin = webvowl.modules.pickAndPin(),
	selectionDetailDisplayer = webvowl.modules.selectionDetailsDisplayer(sidebar.updateSelectionInformation),
	statistics = webvowl.modules.statistics(),
	subclassFilter = webvowl.modules.subclassFilter(),
	setOperatorFilter = webvowl.modules.setOperatorFilter();
	/** Переопределение парсера для графа  */
	graph.setParser(owlParser);
	graph.setI18N(i18n);

class OWLGraph extends React.Component {

	/** Список ссылок на узлы в отображении графа  */
	refsEx = {
		mainRef: React.createRef(),
		canvasArea: React.createRef(),
		loading_info: React.createRef(),
		show_loadingInfo_button: React.createRef(),
		loadingInfo_container: React.createRef(),
		loadingIndicator_closeButton: React.createRef(),
		reloadCachedOntology: React.createRef(),
		modeOfOperationString: React.createRef(),
		vowlGraph: React.createRef(),
		leftSideBarCollapseButton: React.createRef(),
		sidebarExpandButton: React.createRef(),
		containerForLeftSideBar: React.createRef(),
		leftSideBarContent: React.createRef(),
		menuContainer: React.createRef(),
		m_filter: React.createRef(),
		nodeDegreeFilteringOption: React.createRef(),
		m_search: React.createRef(),
		swipeBarContainer: React.createRef(),
		menuElementContainer: React.createRef(),
		c_search: React.createRef(),
		locateSearchResult: React.createRef(),
		c_filter_a: React.createRef(),
		scrollRightButton: React.createRef(),
		scrollLeftButton: React.createRef(),
		zoomSlider: React.createRef(),
		centerGraphButton: React.createRef(),
		zoomInButton: React.createRef(),
		zoomSliderParagraph: React.createRef(),
		zoomOutButton: React.createRef(),
		detailsArea: React.createRef(),
		blockGraphInteractions: React.createRef(),
		WarningErrorMessagesContainer: React.createRef(),
		WarningErrorMessages: React.createRef(),
		DirectInputContent: React.createRef(),
	};
	
	constructor(props, context) {
		super(props, context)
		this.state = {
			contentHash: undefined
		}
		this.helper = new owlResponseHelper(null);
		this.helperVowl = new vowlResponseHelper(null); 		
		this.loadOntologyFromText = this.loadOntologyFromText.bind(this);
	}

	getOptions() {
		return webvowl.opts;
	};
	getGraph() {
		return webvowl.gr;
	};


	componentDidMount() {
		options.supportedGraph("vowl");
		this.updateGraph(true); //ПЕрвый раз
	}

	componentWillUnmount(){
		//Повторная установка обработчика заменит предыдущий.
		d3.select(window).on("resize", ()=> console.log('OWLGraph unmount'));
	}

	componentDidUpdate() {
		this.updateGraph(false); //Второй раз
	}

	/** Для обновления используются данных из content
	 * Загрузка осуществляется методом  loadingModule.parseUrlAndLoadOntology(false, content);
	 */
	updateGraph(mount=true) {
		//console.log("OWLGraph.js updateGraph", this);

		window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (f) { return setTimeout(f, 1000 / 60); }; // simulate calling code 60
		window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || function (requestID) { clearTimeout(requestID); }; //fall back

		options.graphContainerSelector(GRAPH_SELECTOR);
		options.selectionModules([]);
		options.selectionModules().push(focuser);
		options.selectionModules().push(selectionDetailDisplayer);
		options.selectionModules().push(pickAndPin);
		options.selectionModules().push(linker);

		options.filterModules([]);
		options.filterModules().push(emptyLiteralFilter);
		options.filterModules().push(statistics);

		options.filterModules().push(nodeDegreeFilter);
		options.filterModules().push(datatypeFilter);
		options.filterModules().push(objectPropertyFilter);
		options.filterModules().push(subclassFilter);
		options.filterModules().push(disjointFilter);
		options.filterModules().push(setOperatorFilter);
		options.filterModules().push(nodeScalingSwitch);
		options.filterModules().push(compactNotationSwitch);
		options.filterModules().push(colorExternalsSwitch);

		//Повторная установка обработчика заменит предыдущий.
		d3.select(window).on("resize", ()=> this.adjustSize());

		if (mount){
			exportMenu.setup();
			gravityMenu.setup();
			filterMenu.setup(this.refsEx, datatypeFilter, objectPropertyFilter, subclassFilter, disjointFilter, setOperatorFilter, nodeDegreeFilter, i18n);
			modeMenu.setup(pickAndPin, nodeScalingSwitch, compactNotationSwitch, colorExternalsSwitch);
			pauseMenu.setup();
			sidebar.setup(this.refsEx);
			loadingModule.setup(this.refsEx, i18n);
			leftSidebar.setup(this.refsEx);
			editSidebar.setup();
			debugMenu.setup();
		}
		var agentVersion = this.getInternetExplorerVersion();
		if (agentVersion > 0 && agentVersion <= 11) {
			// console.info("Agent version " + agentVersion);
			// console.warn("This agent is not supported");
			d3.select("#browserCheck").classed("hidden", false);
			d3.select("#killWarning").classed("hidden", true);
			d3.select("#optionsArea").classed("hidden", true);
			d3.select("#logo").classed("hidden", true);
		} else {
			d3.select("#logo").classed("hidden", false);
			if (agentVersion === 12) {
				// allow Mircosoft Edge Browser but with warning
				d3.select("#browserCheck").classed("hidden", false);
				d3.select("#killWarning").classed("hidden", false);
			} else {
				d3.select("#browserCheck").classed("hidden", true);
			}

			if (mount){
				resetMenu.setup([gravityMenu, filterMenu, modeMenu, focuser, selectionDetailDisplayer, pauseMenu]);
				searchMenu.setup(this.refsEx);
				navigationMenu.setup(this.refsEx);
				zoomSlider.setup(this.refsEx);
			}

			// give the options the pointer to the some menus for import and export
			options.literalFilter(emptyLiteralFilter);
			options.nodeDegreeFilter(nodeDegreeFilter);
			options.loadingModule(loadingModule);
			options.filterMenu(filterMenu);
			options.modeMenu(modeMenu);
			options.gravityMenu(gravityMenu);
			options.pausedMenu(pauseMenu);
			options.pickAndPinModule(pickAndPin);
			options.resetMenu(resetMenu);
			options.searchMenu(searchMenu);
			options.ontologyMenu(ontologyMenu);
			options.navigationMenu(navigationMenu);
			options.sidebar(sidebar);
			options.leftSidebar(leftSidebar);
			options.editSidebar(editSidebar);
			options.exportMenu(exportMenu);
			options.graphObject(graph);
			options.zoomSlider(zoomSlider);
			options.warningModule(warningModule);
			options.directInputModule(directInputMod);
			options.datatypeFilter(datatypeFilter);
			options.objectPropertyFilter(objectPropertyFilter);
			options.subclassFilter(subclassFilter);
			options.setOperatorFilter(setOperatorFilter);
			options.disjointPropertyFilter(disjointFilter);
			options.focuserModule(focuser);
			options.colorExternalsModule(colorExternalsSwitch);
			options.compactNotationModule(compactNotationSwitch);

			options.statistics(statistics);
			
			ontologyMenu.setup(this.loadOntologyFromText);
			if (mount){
				configMenu.setup();
			}

			leftSidebar.showSidebar(0);
			leftSidebar.hideCollapseButton(true);


			graph.start();

			var modeOp = d3.select("#modeOfOperationString");
			modeOp.style("font-size", "0.6em");
			modeOp.style("font-style", "italic");

			this.adjustSize();
			var defZoom;
			var w = graph.options().width();
			var h = graph.options().height();
			defZoom = Math.min(w, h) / 1000;

			var hideDebugOptions = true;
			if (hideDebugOptions === false) { graph.setForceTickFunctionWithFPS(); }

			graph.setDefaultZoom(defZoom);
			d3.selectAll(".debugOption").classed("hidden", hideDebugOptions);

			// prevent backspace reloading event
			var htmlBody = d3.select("body");
			d3.select(document).on("keydown", function (e) {
				if (d3.event.keyCode === 8 && d3.event.target === htmlBody.node()) {
					// we could add here an alert
					d3.event.preventDefault();
				}
				// using ctrl+Shift+d as debug option
				if (d3.event.ctrlKey && d3.event.shiftKey && d3.event.keyCode === 68) {
					graph.options().executeHiddenDebugFeatuers();
					d3.event.preventDefault();
				}
			});
			if (d3.select("#maxLabelWidthSliderOption")) {
				var setValue = !graph.options().dynamicLabelWidth();
				d3.select("#maxLabelWidthSlider").node().disabled = setValue;
				d3.select("#maxLabelWidthvalueLabel").classed("disabledLabelForSlider", setValue);
				d3.select("#maxLabelWidthDescriptionLabel").classed("disabledLabelForSlider", setValue);
			}

			d3.select((this.refsEx.blockGraphInteractions.current)?this.refsEx.blockGraphInteractions.current:"#blockGraphInteractions").style("position", "absolute")
				.style("top", "0")
				.style("background-color", "#bdbdbd")
				.style("opacity", "0.5")
				.style("pointer-events", "auto")
				.style("width", graph.options().width() + "px")
				.style("height", graph.options().height() + "px")
				.on("click", function () {
					d3.event.preventDefault();
					d3.event.stopPropagation();
				})
				.on("dblclick", function () {
					d3.event.preventDefault();
					d3.event.stopPropagation();
				});

			d3.select("#direct-text-input").on("click", function () { directInputMod.setDirectInputMode(); });
			d3.select(this.refsEx.blockGraphInteractions.current).node().draggable = false;
			options.prefixModule(webvowl.util.prefixTools(graph));
			this.adjustSize();
			//Установить параметры отображения правой панели
			//console.log("OWLGraph.js sidebar.updateOntologyInformation(undefined, statistics)");
			sidebar.updateOntologyInformation(undefined, statistics);
			//Содержимое онтологии. При созданнии онтологии content может отсутствовать (см. вызов в componentDidMount())
			const {content, vowl} = this.props;
			//Вариант 
			if (content){
				owlParser.setHelper(this.helper);
				const contentHash = hashCode(JSON.stringify(content));
				if (contentHash!= this.state.contentHash){
					loadingModule.parseUrlAndLoadOntology(false, content, this.helper); // loads automatically the ontology provided by the parameters
					this.setState({contentHash});
				}
				sidebar.updateOntologyInformation(this.helper, statistics);				
			};
			if (vowl){
				owlParser.setHelper(this.helperVowl);
				const contentHash = hashCode(JSON.stringify(vowl));
				if (contentHash!= this.state.contentHash){
					loadingModule.parseUrlAndLoadOntology(false, vowl, this.helperVowl); // loads automatically the ontology provided by the parameters
					this.setState({contentHash});
				}
				sidebar.updateOntologyInformation(this.helperVowl, statistics);				
			};

			options.debugMenu(debugMenu);
			debugMenu.updateSettings();

			// connect the reloadCachedVersionButton
			d3.select("#reloadSvgIcon").on("click", function () {
				if (d3.select("#reloadSvgIcon").node().disabled === true) {
					graph.options().ontologyMenu().clearCachedVersion();
					return;
				}
				d3.select((this.refsEx.reloadCachedOntology.current)?this.refsEx.reloadCachedOntology.current:"#reloadCachedOntology").classed("hidden", true);
				graph.options().ontologyMenu().reloadCachedOntology();

			});
			// add the initialized objects
			webvowl.opts = options;
			webvowl.gr = graph;
			//Найдём ввыбранный элемент
			if (graph.getUnfilteredData() && this.props.selected){
				if (Array.isArray(graph.getUnfilteredData().nodes)){
					const node = graph.getUnfilteredData().nodes.filter(item => {
						if (item.iri()==this.props.selected) return true;
						//Проверим на наличии iri в списке эквивалентов
						if (Array.isArray(item.equivalents()) && item.equivalents().length>0){
							return item.equivalents().filter(item => item.iri()==this.props.selected).length>0;
						}
						return false;
					});
					//console.log("OWLGraph.js update after node", node, this.props.selected);
					if (node.length>0){
						linker.iri(node[0].iri());
						//Фокусируем
						options.focuserModule().handle(node[0], true);
						//Обновляем информацию об узле
						sidebar.updateSelectionInformation(node[0]);
						//Подсвечиваем красным кругом
						graph.highLightNodes([node[0].id()]);
						//Позиционируем на элементе
						graph.zoomToElementInGraph(node[0]);
					}
				}
				if (Array.isArray(graph.getUnfilteredData().properties)){
					const property = graph.getUnfilteredData().properties.filter(item => item.iri()==this.props.selected);
					//console.log("OWLGraph.js update after property", property);
					if (property.length>0) options.focuserModule().handle(property[0], true);
				}
			}
		}
	}

	/** Загрузка онтологии из текста. Метод присваивается ontologyMenu.setup. 
	 * функция возвращается вызовом ontologyMenu.getLoadingFunction при парсинге онтологии
	 * см. loadingModule.parseOntologyContent(content)
	  */
	loadOntologyFromText(jsonText, filename, alternativeFilename) {
		d3.select(this.refsEx.reloadCachedOntology.current).classed("hidden", true);
		pauseMenu.reset();
		graph.options().navigationMenu().hideAllMenus();

		if ((jsonText === undefined && filename === undefined) || (jsonText.length === 0)) {
			loadingModule.notValidJsonFile();
			return;
		}
		graph.editorMode(); // updates the checkbox		
		const realHelper = (jsonText !== null && typeof jsonText === 'object' && !Array.isArray(jsonText))? this.helperVowl : this.helper;
		var data;
		if (jsonText) {
			// validate JSON FILE
			var validJSON;
			try {
				data = (jsonText !== null && typeof jsonText === 'object' && !Array.isArray(jsonText))? jsonText : JSON.parse(jsonText);
				//Зафиксируем данные в sparqlResponseHelper
				realHelper.setResponse(data);
				realHelper.setConversionSettings(this.props.settings);
				validJSON = true;
			} catch (e) {
				validJSON = false;
			}
			if (validJSON === false) {
				// the server output is not a valid json file
				loadingModule.notValidJsonFile();
				return;
			}

			if (!filename) {
				// First look if an ontology title exists, otherwise take the alternative filename
				//var ontologyNames = data.header ? data.header.title : undefined;
				var ontologyNames = data.header ? realHelper.getTitle() : undefined;
				var ontologyName = languageTools.textInLanguage(ontologyNames);

				if (ontologyName) {
					filename = ontologyName;
				} else {
					filename = alternativeFilename;
				}
			}
		}


		// check if we have graph data
		var classCount = realHelper.getClasses().length;
		//if (data.class !== undefined) { classCount = data.class.length; }

		var loadEmptyOntologyForEditing = false;
		if (location.hash.indexOf("#new_ontology") !== -1) {
			loadEmptyOntologyForEditing = true;
			newOntologyCounter++;
			d3.select("#empty").node().href = "#opts=editorMode=true;#new_ontology" + newOntologyCounter;
		}
		
		if (classCount === 0 && graph.editorMode() === false && loadEmptyOntologyForEditing === false) {
			// generate message for the user;
			loadingModule.emptyGraphContentError();
		} else {
			loadingModule.validJsonFile();
			ontologyMenu.setCachedOntology(filename, jsonText);
			exportMenu.setJsonText(jsonText);
			options.data(realHelper.getData()); //options.data(data);
			graph.options().loadingModule().setPercentMode();
			if (loadEmptyOntologyForEditing === true) {
				graph.editorMode(true);
			}
			//nodeDegreeFilter.setDegreeSetter(0);
			//Собственно парсинг JSON струкутуры VOWL
			graph.load();
			//console.log("OWLGraph.js loadOntologyFromText(jsonText, filename, alternativeFilename) graph.load();", graph.getClassNodes());
			sidebar.updateOntologyInformation(realHelper, statistics);
			exportMenu.setFilename(filename);
			graph.updateZoomSliderValueFromOutside();
			this.adjustSize();

			var flagOfCheckBox = d3.select("#editorModeModuleCheckbox").node().checked;
			//Включает emptyLiteralFilter  - из-за этого не показывается Thing не имеющий связи
			graph.editorMode(flagOfCheckBox);// update gui
		}
	}

	/** Определяется размер видимой области графа */
	adjustSize(args) {
		//Для формирования размерности визуальных элементов			
		//console.log("OWLGraph.js adjustSize", this.refs);
		let innerHeight = (this.refsEx.mainRef && this.refsEx.mainRef.current)?this.refsEx.mainRef.current.clientHeight : window.innerHeight;
		if (innerHeight<880) innerHeight=880;
		const innerWidth = (this.refsEx.mainRef && this.refsEx.mainRef.current)?this.refsEx.mainRef.current.clientWidth : window.innerWidth;
		//console.log("OWLGraph.js adjustSize", this.viz, d3.select(this.viz), d3.select(undefined), this.viz.current);
		var graphContainer = d3.select("#graph"), //d3.select(this.viz) // d3.select(GRAPH_SELECTOR),
			svg = graphContainer.select("svg"),
			height = innerHeight - 40,
			width = innerWidth - (innerWidth * 0.22);
		if (sidebar.getSidebarVisibility() === "0") {
			height = innerHeight - 40;
			width = innerWidth;
		}
		directInputMod.updateLayout();
		d3.select("#blockGraphInteractions").style("width", innerWidth + "px");
		d3.select("#blockGraphInteractions").style("height", innerHeight + "px");

		d3.select("#WarningErrorMessagesContainer").style("width", width + "px");
		d3.select("#WarningErrorMessagesContainer").style("height", height + "px");

		d3.select("#WarningErrorMessages").style("max-height", (height - 12) + "px");

		graphContainer.style("height", height + "px");
		//console.log("OWLGraph.js adjustSize", innerWidth, width, d3, this.refs, this.refs.vowlGraph, graphContainer, svg);
		svg.attr("width", width).attr("height", height);

		options.width(width).height(height);

		graph.updateStyle();
		//console.log("OWLGraph.js adjustSize", args, this, this.refs);
		if (this.isTouchDevice() === true) {
			if (graph.isEditorMode() === true)
				d3.select("#modeOfOperationString").node().innerHTML = "touch able device detected";
			graph.setTouchDevice(true);

		} else {
			if (graph.isEditorMode() === true)
				d3.select("#modeOfOperationString").node().innerHTML = "point & click device detected";
			graph.setTouchDevice(false);
		}

		d3.select(this.refsEx.loadingInfo_container.current).style("height", 0.5 * (height - 80) + "px");
		loadingModule.checkForScreenSize();

		this.adjustSliderSize();
		// update also the padding options of loading and the logo positions;
		var warningDiv = d3.select("#browserCheck");
		if (warningDiv.classed("hidden") === false) {
			var offset = 10 + warningDiv.node().getBoundingClientRect().height;
			d3.select("#logo").style("padding", offset + "px 10px");
		} else {
			// remove the dynamic padding from the logo element;
			d3.select("#logo").style("padding", "10px");
		}

		// scrollbar tests;
		var element = d3.select(this.refsEx.menuElementContainer.current).node();
		var maxScrollLeft = element.scrollWidth - element.clientWidth;
		var leftButton = d3.select(this.refsEx.scrollLeftButton.current);
		var rightButton = d3.select(this.refsEx.scrollRightButton.current);
		if (maxScrollLeft > 0) {
			// show both and then check how far is bar;
			rightButton.classed("hidden", false);
			leftButton.classed("hidden", false);
			navigationMenu.updateScrollButtonVisibility();
		} else {
			// hide both;
			rightButton.classed("hidden", true);
			leftButton.classed("hidden", true);
		}

		// adjust height of the leftSidebar element;
		editSidebar.updateElementWidth();
	}

	adjustSliderSize() {
		// TODO: refactor and put this into the slider it self
		var height =  (this.refsEx.mainRef.current)?this.refsEx.mainRef.current.clientHeight -40: window.innerHeight -40; //window.innerHeight - 40;
		var fullHeight = height;
		var zoomOutPos = height - 30;
		var sliderHeight = 150;

		// assuming DOM elements are generated in the index.html
		// todo: refactor for independent usage of graph and app
		if (fullHeight < 150) {
			// hide the slider button;
			d3.select("#zoomSliderParagraph").classed("hidden", true);
			d3.select("#zoomOutButton").classed("hidden", true);
			d3.select("#zoomInButton").classed("hidden", true);
			d3.select("#centerGraphButton").classed("hidden", true);
			return;
		}
		d3.select("#zoomSliderParagraph").classed("hidden", false);
		d3.select("#zoomOutButton").classed("hidden", false);
		d3.select("#zoomInButton").classed("hidden", false);
		d3.select("#centerGraphButton").classed("hidden", false);

		var zoomInPos = zoomOutPos - 20;
		var centerPos = zoomInPos - 20;
		if (fullHeight < 280) {
			// hide the slider button;
			d3.select("#zoomSliderParagraph").classed("hidden", true);//var sliderPos=zoomOutPos-sliderHeight;
			d3.select("#zoomOutButton").style("top", zoomOutPos + "px");
			d3.select("#zoomInButton").style("top", zoomInPos + "px");
			d3.select("#centerGraphButton").style("top", centerPos + "px");
			return;
		}

		var sliderPos = zoomOutPos - sliderHeight;
		zoomInPos = sliderPos - 20;
		centerPos = zoomInPos - 20;
		d3.select("#zoomSliderParagraph").classed("hidden", false);
		d3.select("#zoomOutButton").style("top", zoomOutPos + "px");
		d3.select("#zoomInButton").style("top", zoomInPos + "px");
		d3.select("#centerGraphButton").style("top", centerPos + "px");
		d3.select("#zoomSliderParagraph").style("top", sliderPos + "px");
	}

	isTouchDevice() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}


	getInternetExplorerVersion() {
		var ua,
			re,
			rv = -1;

		// check for edge
		var isEdge = /(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:|\bEdge\/)(\d+)/.test(navigator.userAgent);
		if (isEdge) {
			rv = parseInt("12");
			return rv;
		}

		var isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
		if (isIE11) {
			rv = parseInt("11");
			return rv;
		}
		if (navigator.appName === "Microsoft Internet Explorer") {
			ua = navigator.userAgent;
			re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
			if (re.exec(ua) !== null) {
				rv = parseFloat(RegExp.$1);
			}
		} else if (navigator.appName === "Netscape") {
			ua = navigator.userAgent;
			re = new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})");
			if (re.exec(ua) !== null) {
				rv = parseFloat(RegExp.$1);
			}
		}
		return rv;
	}

	onLinkedElement(e, IRI){
		e.preventDefault();
		//console.log("OWLGraph.js onLinkedElement", linker.iri());
		this.props.dispatch(LinkerActions.show(linker.iri()));
	}

	render() {
		console.log(this);
		//console.log(JSON.stringify(this.props.content)); console.log(JSON.stringify(this.props.settings));
		//selectionDetailDisplayer()
		return (
			<main ref={this.refsEx.mainRef} style={{lineHeight: 1}}>
				<section ref={this.refsEx.canvasArea} id="canvasArea">
					<div id="browserCheck" className="hidden">
						WebVOWL does not work properly in Internet Explorer and Microsoft Edge.
						Please use another browser, such as
				<a href="http://www.mozilla.org/firefox/">Mozilla Firefox</a>
						or
				<a href="https://www.google.com/chrome/">Google Chrome</a>,
						to run WebVOWL.
				<label id="killWarning">Hide warning</label>
					</div>
					<div id="logo" className="noselect">
						<h2>SemanticPro (WebVOWL) <span></span></h2>
					</div>

					<div ref={this.refsEx.loading_info} id="loading-info" className="hidden">
						<div id="loading-progress" style={{ "borderRadius": "10px" }} >
							<div className="hidden">Загрузка данных... </div>
							<div id="layoutLoadingProgressBarContainer" style={{ paddingBottom: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
								<h4 id="currentLoadingStep" style={{ margin: 0, fontStyle: "italic", paddingBottom: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Оптимизация макета</h4>
								<div id="progressBarContext">
									<div id="progressBarValue" className="busyProgressBar"></div>
								</div>
							</div>
							<div id="loadingInfo_msgBox" style={{ paddingBottom: 0, paddingTop: 0 }}>
								<div ref={this.refsEx.show_loadingInfo_button} id="show-loadingInfo-button" className="accordion-trigger noselect">{i18n.t('graph.load.detail')} </div>
								<div ref={this.refsEx.loadingInfo_container} id="loadingInfo-container"><ul id="bulletPoint_container"></ul></div>
							</div>
							<div>
								<span ref={this.refsEx.loadingIndicator_closeButton} id="loadingIndicator_closeButton" className="">Закрыть предупреждения</span>
							</div>
						</div>
					</div>
					<div id="additionalInformationContainer">
						<div ref={this.refsEx.reloadCachedOntology} id="reloadCachedOntology" className="hidden" title="">

							<svg viewBox="38 -12.5 18 18" className="reloadCachedOntologyIcon btn_shadowed" id="reloadSvgIcon">
								<g>
									<text id="svgStringText" dx="5px" dy="-1px" style={{ fontSize: "9px" }}>Reload ontology</text>
									<path style={{ fill: "#444", strokeWidth: 0 }}
										d="m 42.277542,5.1367119 c -5.405,0 -10.444,1.577 -14.699,4.282 l -5.75,-5.75 0,16.1100001 16.11,0 -6.395,-6.395 c 3.18,-1.787 6.834,-2.82 10.734,-2.82 12.171,0 22.073,9.902 22.073,22.074 0,2.899 -0.577,5.664 -1.599,8.202 l 4.738,2.762 c 1.47,-3.363 2.288,-7.068 2.288,-10.964 0,-15.164 -12.337,-27.5010001 -27.5,-27.5010001 m 11.5,46.7460001 c -3.179,1.786 -6.826,2.827 -10.726,2.827 -12.171,0 -22.073,-9.902 -22.073,-22.073 0,-2.739 0.524,-5.35 1.439,-7.771 l -4.731,-2.851 c -1.375,3.271 -2.136,6.858 -2.136,10.622 0,15.164 12.336,27.5 27.5,27.5 5.406,0 10.434,-1.584 14.691,-4.289 l 5.758,5.759 0,-16.112 -16.111,0 6.389,6.388 z"
										transform="matrix(0.20,0,0,0.20,75,-10)" >
									</path></g>
							</svg>
							<span id="reloadCachedOntologyString" className="noselect" style={{ fontStyle: "italic", fontSize: "10px" }}>Loaded cached ontology</span>
						</div>

						<div id="FPS_Statistics" className="hidden debugOption">FPS: 0 Nodes: 0Links: 0</div>
						<span ref={this.refsEx.modeOfOperationString} className="hidden debugOption" id="modeOfOperationString">режим работы</span>
					</div>
					<div ref={this.refsEx.vowlGraph} id="graph"></div>
					<div className="noselect" >
						<span ref={this.refsEx.leftSideBarCollapseButton} id="leftSideBarCollapseButton" className="btn_shadowed hidden"> &qt; </span>
					</div>
					<div className="noselect" ><span ref={this.refsEx.sidebarExpandButton} id="sidebarExpandButton" className="btn_shadowed"> &qt; </span></div>

					<div ref={this.refsEx.containerForLeftSideBar} id="containerForLeftSideBar">
						<div id="leftSideBar" >
							<div ref={this.refsEx.leftSideBarContent} id="leftSideBarContent" className="hidden">
								<h2 id="leftHeader">Default Element</h2>
								<h3 className=" selectedDefaultElement accordion-trigger noselect accordion-trigger-active" id="defaultClass" title="owl:Class">Class: owl:Class
					</h3>
								<div id="classContainer" className="accordion-container ">
								</div>
								<h3 className="selectedDefaultElement accordion-trigger noselect accordion-trigger-active" title="owl:objectProperty" id="defaultProperty">Property: owl:objectProperty
					</h3>
								<div id="propertyContainer" className="accordion-container ">
								</div>
								<h3 className="selectedDefaultElement accordion-trigger noselect accordion-trigger-active" title="rdfs:Literal" id="defaultDatatype">Datatype: rdfs:Literal
					</h3>
								<div id="datatypeContainer" className="accordion-container ">
								</div>
							</div>
						</div>
					</div>
					<div ref={this.refsEx.menuContainer} id="menuContainer" >
						<ul id="m_select" className="toolTipMenu noselect">
							<li><a href="#foaf" id="foaf">Friend of a Friend (FOAF) vocabulary</a></li>
							<li><a href="#goodrelations" id="goodrelations">GoodRelations Vocabulary for E-Commerce</a></li>
							<li><a href="#muto" id="muto">Modular and Unified Tagging Ontology (MUTO)</a></li>
							<li><a href="#ontovibe" id="ontovibe">Ontology Visualization Benchmark (OntoViBe)</a></li>
							<li><a href="#personasonto" id="personasonto">Personas Ontology (PersonasOnto)</a></li>
							<li><a href="#sioc" id="sioc">SIOC (Semantically-Interlinked Online Communities) Core Ontology</a></li>

							<li><a href="#benchmark" id="benchmark">Benchmark Graph for VOWL</a></li>
							<li className="option" id="converter-option">
								<form className="converter-form" id="iri-converter-form">
									<label htmlFor="iri-converter-input">Custom Ontology:</label>

									<input type="text" id="iri-converter-input" placeholder="Enter ontology IRI" />
									<button type="submit" id="iri-converter-button" disabled>Visualize</button>
								</form>
								<div className="converter-form">
									<input className="hidden" type="file" id="file-converter-input" autocomplete="off" />
									<label className="truncate" id="file-converter-label" htmlFor="file-converter-input">Select ontology file</label>
									<button type="submit" id="file-converter-button" disabled>
										Upload
						</button>

								</div>
								<div id="emptyContainer">
									<a href="#opts=editorMode=true;#new_ontology1" id="empty" style={{ pointerEvents: "none", paddingLeft: 0 }}>Create new ontology</a>
								</div>
								<div>
								</div>
							</li>

						</ul>
						<ul id="m_export" className="toolTipMenu noselect">
							<li><a href="#" download id="exportJson">Export as JSON</a></li>
							<li><a href="#" download id="exportSvg">Export as SVG</a></li>
							<li><a href="#" download id="exportTex">Export as TeX <label style={{ fontSize: "10px" }}>(alpha)</label></a></li>
							<li><a href="#" download id="exportTurtle">Export as TTL <label style={{ fontSize: "10px" }}>(alpha)</label></a></li>

							<li className="option" id="emptyLiHover">
								<div>
									<form className="converter-form" id="url-copy-form">
										<label htmlFor="exportedUrl">Export as URL:</label>
										<input type="text" id="exportedUrl" placeholder="#" />
										<button id="copyBt" title="Copy to clipboard">Copy</button>
									</form>
								</div>
							</li>
						</ul>

						<ul ref={this.refsEx.m_filter} id="m_filter" className="toolTipMenu noselect">
							<li className="toggleOption" id="datatypeFilteringOption"></li>
							<li className="toggleOption" id="objectPropertyFilteringOption"></li>
							<li className="toggleOption" id="subclassFilteringOption"></li>
							<li className="toggleOption" id="disjointFilteringOption"></li>
							<li className="toggleOption" id="setOperatorFilteringOption"></li>
							<li ref={this.refsEx.nodeDegreeFilteringOption} className="slideOption" id="nodeDegreeFilteringOption"></li>
						</ul>
						<ul id="m_config" className="toolTipMenu noselect">
							<li className="toggleOption" id="zoomSliderOption"></li>

							<li className="slideOption" id="classSliderOption"></li>
							<li className="slideOption" id="datatypeSliderOption"></li>
							<li className="toggleOption" id="dynamicLabelWidth"></li>
							<li className="slideOption" id="maxLabelWidthSliderOption"></li>
							<li className="toggleOption" id="nodeScalingOption"></li>
							<li className="toggleOption" id="compactNotationOption"></li>
							<li className="toggleOption" id="colorExternalsOption"></li>
						</ul>

						<ul id="m_modes" className="toolTipMenu noselect">
							<li className="toggleOption" id="editMode"></li>
							<li className="toggleOption" id="pickAndPinOption"></li>
						</ul>

						<ul id="m_debug" className="toolTipMenu noselect">
							<li className=" toggleOption" id="useAccuracyHelper"></li>
							<li className=" toggleOption" id="showDraggerObject"></li>
							<li className=" toggleOption" id="showFPS_Statistics"></li>
							<li className=" toggleOption" id="showModeOfOperation"></li>
						</ul>


						<ul id="m_about" className="toolTipMenu">
							<li><a href="license.txt" target="_blank">MIT License &copy; 2014-2019</a></li>
							<li id="credits" className="option">WebVOWL Developers:<br />
								Vincent Link, Steffen Lohmann, Eduard Marbach, Stefan Negru, Vitalis Wiens
				</li>
						</ul>
						<ul ref={this.refsEx.m_search} id="m_search" className="toolTipMenu"></ul>
					</div>
					<div ref={this.refsEx.swipeBarContainer} className="noselect" id="swipeBarContainer" style={{ position: "absolute"}}>
						<ul ref={this.refsEx.menuElementContainer} id="menuElementContainer" >
							<li ref={this.refsEx.c_search} id="c_search" className="inner-addon left-addon">
								<i className="searchIcon" >
									<svg viewBox="0 0 24 24" height="100%" width="100%" style={{ pointerEvents: "none", display: "block" }}>
										<g ><path id="magnifyingGlass" style={{ fill: "#666", strokeWidth: 0 }}
											d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z">
										</path></g></svg>
								</i>
								<input className="searchInputText" type="text" id="search-input-text" placeholder={i18n.t('graph.search.placeholder')} />
							</li>
							<li id="c_locate" >
								<a ref={this.refsEx.locateSearchResult} style={{ padding: "0 8px 5px 8px"}} draggable="false" title={i18n.t('graph.search.noFind')}
									href="#" id="locateSearchResult">&#8982;
					</a>
							</li>
							<li id="c_select"  style={{display: "none" }}>
								<a draggable="false" href="#">
									<i>
										<svg viewBox="0 0 24 24" className="menuElementSvgElement" >
											<g><path style={{ fill: "#fff", strokeWidth: 0 }} d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
												transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
											</path></g>
										</svg>
									</i> Ontology</a>
							</li>
							<li id="c_export" style={{display: "none" }} ><a draggable="false" href="#">
								<i>
									<svg viewBox="0 0 24 24" className="menuElementSvgElement" >
										<g><path style={{ fill: "#fff", strokeWidth: 0 }} d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
											transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
										</path></g>
									</svg>
								</i> Export</a></li>
							<li id="c_filter" ref={this.refsEx.c_filter_a} ><a draggable="false" href="#">
								<i>
									<svg viewBox="0 0 24 24" className="menuElementSvgElement">
										<g><path style={{ fill: "#fff", strokeWidth: 0 }} d="M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
											transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
										</path></g>
									</svg>
								</i>{i18n.t('graph.filter.title')}</a></li>
							<li id="c_config"  ><a draggable="false" href="#">
								<i><svg viewBox="0 0 24 24" className="menuElementSvgElement">
									<g><path style={{ fill: "#fff", strokeWidth: 0 }}
										d="m 21.163138,13.127428 0,-2.356764 -2.546629,-0.424622 C 18.439272,9.5807939 18.137791,8.8661419 17.733863,8.218291 L 19.2356,6.116978 17.569296,4.450673 15.466841,5.951269 C 14.818953,5.548483 14.104338,5.24586 13.33909,5.067482 l -0.424622,-2.545488 -2.356764,0 -0.424622,2.545488 C 9.3689769,5.24586 8.6531829,5.548519 8.0053319,5.951269 l -2.102455,-1.500596 -1.666304,1.666305 1.501737,2.101313 c -0.403928,0.6467469 -0.705409,1.3625029 -0.882646,2.127751 l -2.546629,0.424622 0,2.356764 2.546629,0.424622 c 0.177237,0.765248 0.478718,1.4799 0.882646,2.127751 l -1.501737,2.102455 1.666304,1.666304 2.103596,-1.501737 c 0.646747,0.403928 1.362504,0.705409 2.1266091,0.882646 l 0.424622,2.546629 2.356764,0 0.424622,-2.546629 c 0.764106,-0.177237 1.4799,-0.478718 2.127751,-0.882646 l 2.102455,1.501737 1.666304,-1.666304 -1.501737,-2.102455 c 0.403928,-0.647888 0.705409,-1.363645 0.882646,-2.127751 l 2.546629,-0.424622 z m -9.427053,3.535144 c -2.6030431,0 -4.7135241,-2.110517 -4.7135241,-4.713527 0,-2.6030071 2.110518,-4.713525 4.7135241,-4.713525 2.60301,0 4.713527,2.1105179 4.713527,4.713525 0,2.60301 -2.110481,4.713527 -4.713527,4.713527 z"
										transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
									</path>
									</g>
								</svg></i>{i18n.t('graph.options.title')}</a>
							</li>
							<li id="c_modes" style={{display: "none" }}  ><a draggable="false" href="#">
								<i>
									<svg viewBox="0 0 24 24" className="menuElementSvgElement">
										<g><path style={{ fill: "#fff", strokeWidth: 0 }}
											d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
											transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
										</path></g>
									</svg>
								</i>Modes</a></li>
							<li id="c_reset" style={{display: "none" }}><a draggable="false" id="reset-button" href="#" type="reset">
								<i>
									<svg viewBox="0 0 24 24" className="menuElementSvgElement">
										<g><path style={{ fill: "#fff", strokeWidth: 0 }}
											d="m 12,5 0,-4 5,5 -5,5 0,-4 c -3.31,0 -6,2.69 -6,6 0,3.31 2.69,6 6,6 3.31,0 6,-2.69 6,-6 l 2,0 c 0,4.42 -3.58,8 -8,8 C 7.58,21 4,17.42 4,13 4,8.58 7.58,5 12,5 Z"
											transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
										</path></g>
									</svg>
								</i>Reset</a></li>
							<li id="c_pause" style={{display: "none" }}  ><a draggable="false" id="pause-button" href="#" style={{ padding: "9px 8px 12px 8px" }}>Pause</a></li>
							<li id="c_debug" className="debugOption" style={{display: "none" }} ><a id="debugMenuHref" draggable="false" href="#">
								<i> <svg viewBox="0 0 24 24" className="menuElementSvgElement">
									<g><path style={{ fill: "#fff", strokeWidth: 0 }}
										d="M 20,8 17.19,8 C 16.74,7.22 16.12,6.55 15.37,6.04 L 17,4.41 15.59,3 13.42,5.17 C 12.96,5.06 12.49,5 12,5 11.51,5 11.04,5.06 10.59,5.17 L 8.41,3 7,4.41 8.62,6.04 C 7.88,6.55 7.26,7.22 6.81,8 L 4,8 4,10 6.09,10 C 6.04,10.33 6,10.66 6,11 l 0,1 -2,0 0,2 2,0 0,1 c 0,0.34 0.04,0.67 0.09,1 L 4,16 l 0,2 2.81,0 c 1.04,1.79 2.97,3 5.19,3 2.22,0 4.15,-1.21 5.19,-3 l 2.81,0 0,-2 -2.09,0 C 17.96,15.67 18,15.34 18,15 l 0,-1 2,0 0,-2 -2,0 0,-1 c 0,-0.34 -0.04,-0.67 -0.09,-1 L 20,10 Z m -4,4 0,3 c 0,0.22 -0.03,0.47 -0.07,0.7 L 15.83,16.35 15.46,17 C 14.74,18.24 13.42,19 12,19 10.58,19 9.26,18.23 8.54,17 L 8.17,16.36 8.07,15.71 C 8.03,15.47 8,15.22 8,15 L 8,11 C 8,10.78 8.03,10.53 8.07,10.3 L 8.17,9.65 8.54,9 C 8.84,8.48 9.26,8.03 9.75,7.69 L 10.32,7.3 11.06,7.12 C 11.37,7.04 11.69,7 12,7 c 0.32,0 0.63,0.04 0.95,0.12 l 0.68,0.16 0.61,0.42 c 0.5,0.34 0.91,0.78 1.21,1.31 l 0.38,0.65 0.1,0.65 C 15.97,10.53 16,10.78 16,11 Z"
										transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
									</path></g>
								</svg>
								</i>
								Debug</a></li>
							<li id="c_about"><a draggable="false" href="#">
								<i> <svg viewBox="0 0 24 24" className="menuElementSvgElement">
									<g><path style={{ fill: "#fff", strokeWidth: 0 }}
										d="m 10.08,10.86 c 0.05,-0.33 0.16,-0.62 0.3,-0.87 0.14,-0.25 0.34,-0.46 0.59,-0.62 0.24,-0.15 0.54,-0.22 0.91,-0.23 0.23,0.01 0.44,0.05 0.63,0.13 0.2,0.09 0.38,0.21 0.52,0.36 0.14,0.15 0.25,0.33 0.34,0.53 0.09,0.2 0.13,0.42 0.14,0.64 l 1.79,0 C 15.28,10.33 15.19,9.9 15.02,9.51 14.85,9.12 14.62,8.78 14.32,8.5 14.02,8.22 13.66,8 13.24,7.84 12.82,7.68 12.36,7.61 11.85,7.61 11.2,7.61 10.63,7.72 10.15,7.95 9.67,8.18 9.27,8.48 8.95,8.87 8.63,9.26 8.39,9.71 8.24,10.23 8.09,10.75 8,11.29 8,11.87 l 0,0.27 c 0,0.58 0.08,1.12 0.23,1.64 0.15,0.52 0.39,0.97 0.71,1.35 0.32,0.38 0.72,0.69 1.2,0.91 0.48,0.22 1.05,0.34 1.7,0.34 0.47,0 0.91,-0.08 1.32,-0.23 0.41,-0.15 0.77,-0.36 1.08,-0.63 0.31,-0.27 0.56,-0.58 0.74,-0.94 0.18,-0.36 0.29,-0.74 0.3,-1.15 l -1.79,0 c -0.01,0.21 -0.06,0.4 -0.15,0.58 -0.09,0.18 -0.21,0.33 -0.36,0.46 -0.15,0.13 -0.32,0.23 -0.52,0.3 -0.19,0.07 -0.39,0.09 -0.6,0.1 C 11.5,14.86 11.2,14.79 10.97,14.64 10.72,14.48 10.52,14.27 10.38,14.02 10.24,13.77 10.13,13.47 10.08,13.14 10.03,12.81 10,12.47 10,12.14 l 0,-0.27 c 0,-0.35 0.03,-0.68 0.08,-1.01 z M 12,2 C 6.48,2 2,6.48 2,12 2,17.52 6.48,22 12,22 17.52,22 22,17.52 22,12 22,6.48 17.52,2 12,2 Z m 0,18 C 7.59,20 4,16.41 4,12 4,7.59 7.59,4 12,4 c 4.41,0 8,3.59 8,8 0,4.41 -3.59,8 -8,8 z"
										transform="matrix(0.75,0,0,0.75,3.5,2.5)" >
									</path></g>
								</svg>
								</i>
								About</a></li>
						</ul>
					</div>
					<div ref={this.refsEx.scrollRightButton} className="noselect" id="scrollRightButton">  </div>
					<div ref={this.refsEx.scrollLeftButton} className="noselect" id="scrollLeftButton">  </div>
					<div ref={this.refsEx.zoomSlider} id="zoomSlider" className="btn_shadowed">
						<p ref={this.refsEx.centerGraphButton} className="noselect" id="centerGraphButton">&#8982;</p>
						<p ref={this.refsEx.zoomInButton} className="noselect" id="zoomInButton">+</p>
						<p ref={this.refsEx.zoomSliderParagraph} className="noselect" id="zoomSliderParagraph" > </p>
						<p ref={this.refsEx.zoomOutButton} className="noselect" id="zoomOutButton">-</p>
					</div>
				</section>
				<aside ref={this.refsEx.detailsArea} id="detailsArea" style={{ backgroundColor: "#F5F6FA", position: "absolute", top: "64px" }}>
					<section id="generalDetailsEdit" className="hidden">
						<h1 id="editHeader" style={{ fontSize: "1.1em" }}>Editing Options</h1>
						<h3 className="accordion-trigger noselect accordion-trigger-active">{i18n.t('graph.ontology.title')}</h3>
						<div>
							<div className="textLineEditWithLabel">
								<form className="converter-form-Editor " id="titleEditForm">
									<label className="EditLabelForInput" id="titleEditor-label" htmlFor="titleEditor" title={i18n.t('graph.ontology.dcTitle')}>{i18n.t('graph.ontology.dcTitleHint')}:</label>
									<input className="modifiedInputStyle" type="text" id="titleEditor" autocomplete="off" value="" />
								</form>
							</div>
							<div className="textLineEditWithLabel">
								<form className="converter-form-Editor " id="iriEditForm">
									<label className="EditLabelForInput" id="iriEditor-label" htmlFor="iriEditor">IRI:</label>
									<input type="text" id="iriEditor" autocomplete="off" value="" />
								</form>
							</div>
							<div className="textLineEditWithLabel">
								<form className="converter-form-Editor " id="versionEditForm">
									<label className="EditLabelForInput" id="versionEditor-label" htmlFor="versionEditor" title={i18n.t('graph.ontology.version')}>{i18n.t('graph.ontology.versionHint')}:</label>
									<input type="text" id="versionEditor" value="" autocomplete="off" />
								</form>
							</div>
							<div className="textLineEditWithLabel">
								<form className="converter-form-Editor " id="authorsEditForm">
									<label className="EditLabelForInput" id="authorsEditor-label" htmlFor="authorsEditor" title={i18n.t('graph.ontology.creator')}>{i18n.t('graph.ontology.creatorHint')}:</label>
									<input type="text" id="authorsEditor" value="" autocomplete="off" />
								</form>
							</div>
							<h4 className="subAccordion accordion-trigger noselect">{i18n.t('graph.prefix.title')}</h4>
							<div className="subAccordionDescription" id="containerForPrefixURL">
								<div id="prefixURL_Description">
									<span className="boxed ">Prefix</span>
									<span className="boxed">IRI</span>
								</div>
								<div id="prefixURL_Container"></div>
								<div align="center" id="containerForAddPrefixButton" >
									<button id="addPrefixButton">Add Prefix</button>
								</div>
							</div>
						</div>

						<h3 className="accordion-trigger noselect">{i18n.t('graph.description.title')}</h3>
						<div>
							<textarea rows="4" cols="25" title="Ontology description as dc:description" className="descriptionTextClass" id="descriptionEditor" ></textarea>
						</div>
						<h3 className="accordion-trigger noselect accordion-trigger-active">Selected Element</h3>
						<div>
							<div id="selectedElementProperties" className="hidden">
								<div className="textLineEditWithLabel">
									<form className="converter-form-Editor " id="element_iriEditForm">
										<label className="EditLabelForInput" id="element_iriEditor-label" htmlFor="element_iriEditor">IRI:</label>
										<input type="text" id="element_iriEditor" autocomplete="off" value="" />
									</form>
								</div>
								<div className="textLineEditWithLabel">
									<form className="converter-form-Editor " id="element_labelEditForm">
										<label className="EditLabelForInput" id="element_labelEditor-label" htmlFor="element_labelEditor">{i18n.t('graph.detail.lable')}:</label>
										<input type="text" id="element_labelEditor" autocomplete="off" value="" />
									</form>
								</div>
								<div className="textLineEditWithLabel">
									<form className="converter-form-Editor" id="typeEditForm">
										<label className="EditLabelForInput" id="typeEditor-label" htmlFor="typeEditor">{i18n.t('graph.detail.type')}:</label>
										<select id="typeEditor" className="dropdownMenuClass"></select>
									</form>
									<form className="converter-form-Editor" id="typeEditForm_datatype">
										<label className="EditLabelForInput" id="typeEditor_datatype-label" htmlFor="typeEditor_datatype">{i18n.t('graph.detail.dataType')}:</label>
										<select id="typeEditor_datatype" className="dropdownMenuClass"></select>
									</form>
								</div>
								<div className="textLineEditWithLabel" id="property_characteristics_Container"> {i18n.t('graph.detail.characteristics')}:
						<div id="property_characteristics_Selection" style={{ paddingTop: "2px" }}> </div>
								</div>

							</div>
							<div id="selectedElementPropertiesEmptyHint">
								{i18n.t('graph.detail.noSelect')}.
				</div>
						</div>

					</section>
					<section id="generalDetails" className="hidden">
						<h1 id="title"></h1>
						<span><a id="about" href=""></a></span>
						<h5>{i18n.t('graph.detail.version')}: <span id="version"></span></h5>
						<h5>{i18n.t('graph.detail.authors')}: <span id="authors"></span></h5>
						<h5>
							<label>{i18n.t('graph.detail.language')}: <select id="language" name="language" size="1"></select></label>
						</h5>
						<h3 className="accordion-trigger noselect accordion-trigger-active">{i18n.t('graph.description.title')}</h3>
						<div className="accordion-container scrollable">
							<p id="description"></p>
						</div>
						<h3 className="accordion-trigger noselect" style={{ display: "none" }}>{i18n.t('graph.metadata.title')}</h3>
						<div id="ontology-metadata" className="accordion-container" style={{ display: "none" }}></div>
						<h3 className="accordion-trigger noselect" onDoubleClick={
							() =>  {
									navigator.clipboard.writeText(statistics.debugContent());
									alert("Statistic content copied!")
								}
							}>{i18n.t('graph.section_statistic')}</h3>
						<div className="accordion-container">
							<p className="statisticDetails">{i18n.t('graph.statistic.classes')}: <span id="classCount"></span></p>
							<p className="statisticDetails">{i18n.t('graph.statistic.objectProperties')}: <span id="objectPropertyCount"></span></p>
							<p className="statisticDetails">{i18n.t('graph.statistic.dataProperties')}: <span id="datatypePropertyCount"></span></p>
							<div className="small-whitespace-separator"></div>
							<p className="statisticDetails">{i18n.t('graph.statistic.individuals')}: <span id="individualCount"></span></p>
							<div className="small-whitespace-separator"></div>
							<p className="statisticDetails">{i18n.t('graph.statistic.nodeCount')}: <span id="nodeCount"></span></p>
							<p className="statisticDetails">{i18n.t('graph.statistic.edgeCount')}: <span id="edgeCount"></span></p>
						</div>
						<h3 className="accordion-trigger noselect" id="selection-details-trigger">{i18n.t('graph.section_details')}</h3>
						<div className="accordion-container" id="selection-details">
							<div id="classSelectionInformation" className="hidden">
								<p className="propDetails" style={{wordBreak: "break-all"}}>URI: <span id="uri"></span></p>
								<p className="propDetails">name: <span id="name"></span></p>
								<p className="propDetails" style={{ display: "none" }}>type: <span id="typeNode"></span></p>
								<p className="propDetails">equiv.: <span id="classEquivUri"></span></p>
								<p className="propDetails">disjoint: <span id="disjointNodes"></span></p>
								<p className="propDetails">charac.: <span id="classAttributes"></span></p>
								<p className="propDetails">individuals: <span id="individuals"></span></p>
								<p className="propDetails">description: <span id="nodeDescription"></span></p>
								<p className="propDetails">comment: <span id="nodeComment"></span></p>
							</div>
							<div id="propertySelectionInformation" className="hidden">
								<p className="propDetails">name: <span id="propname"></span></p>
								<p className="propDetails" style={{ display: "none" }}>type: <span id="typeProp"></span></p>
								<p id="inverse" className="propDetails">inverse: <span></span></p>
								<p className="propDetails">domain: <span id="domain"></span></p>
								<p className="propDetails">range: <span id="range"></span></p>
								<p className="propDetails">subprop.: <span id="subproperties"></span></p>
								<p className="propDetails">superprop.: <span id="superproperties"></span></p>
								<p className="propDetails">equiv.: <span id="propEquivUri"></span></p>
								<p id="infoCardinality" className="propDetails">cardinality: <span></span></p>
								<p id="minCardinality" className="propDetails">min. cardinality: <span></span></p>
								<p id="maxCardinality" className="propDetails">max. cardinality: <span></span></p>
								<p className="propDetails">charac.: <span id="propAttributes"></span></p>
								<p className="propDetails">description: <span id="propDescription"></span></p>
								<p className="propDetails">comment: <span id="propComment"></span></p>
							</div>
							<div id="noSelectionInformation">
								<p><span>{i18n.t('graph.detail.noSelect')}</span></p>
							</div>
						</div>
						<h3 className="accordion-trigger noselect" id="selection-details-trigger" style={{ display: "none" }}>Коллективная работа</h3>
						<div className="accordion-container" id="selection-teamworks" style={{ display: "none" }}>
							<div id="teamworksInformation" className="hidden">
								<Tooltip placement="top" title={"Установка связи с выбранным элементом"}>
                  <Button icon="credit-card" onClick={(e)=> this.onLinkedElement(e, "view")}></Button>
                </Tooltip>
							  <p id="noTeamworks" className="hidden">Нет элементов коллективной роаботы</p>
								<p id="taskDetails" className="hidden">Задания: <span id="tasks"></span></p>
								<p id="requirementDetails" className="hidden">Требования: <span id="requirements"></span></p>
							</div>
							<div id="noTeamworksInformation">
								<p><span>Выберите элемент в графе</span></p>
							</div>
						</div>
						<h3 className="accordion-trigger noselect" id="selection-legend-trigger">{i18n.t('graph.legend.title')}</h3>
						<div className="accordion-container" id="selection-legend">
							<div id="legendInformation" >
								<p id="legendDetails"><span id="legendContent">{i18n.t('graph.legend.detail')} 
								 <a href='https://www.semantic-web-journal.net/system/files/swj1114.pdf' target='_blаnk'>Visualizing Ontologies with VOWL</a></span>
								</p>
							</div>
							<div id="noLegendInformation" className="hidden">
								<p><span>{i18n.t('graph.legend.noLegend')} </span></p>
							</div>
						</div>
					</section>
				</aside>
				<div ref={this.refsEx.blockGraphInteractions} id="blockGraphInteractions" className="hidden"></div>
				<div ref={this.refsEx.WarningErrorMessagesContainer} id="WarningErrorMessagesContainer" className="">
					<div ref={this.refsEx.WarningErrorMessages} id="WarningErrorMessages" className="">
					</div>
				</div>
				<div ref={this.refsEx.DirectInputContent} id="DirectInputContent" className="hidden">
					<div id="direct-text-input-container">
						<textarea rows="4" cols="25" title="Direct Text input as JSON(experimental)" className="directTextInputStyle" id="directInputTextArea"></textarea>
						<div id="di_controls">
							<ul>
								<li> <button id="directUploadBtn">Upload</button></li>
								<li> <button id="close_directUploadBtn">Close</button></li>
								<li id="Error_onLoad" className="hidden">Some text if ERROR</li>
							</ul>
						</div>
					</div>


				</div>
			</main>
		);
	}
}

export default connect(
  (state, props) => {
    const { selected } = state;
    return ({
			selected: selected.uri,
    })
  },
	null,
)(OWLGraph);